/**
 * @param {NodeListOf<Element>} collection
 * @returns Element[]
 */
export default function nodeListToArray (collection) {
  return [].slice.call(collection)
}
